<!-- 快捷加购弹窗 --->
<template>
  <el-dialog
    :title="null"
    :append-to-body="true"
    :destroy-on-close="true"
    custom-class="add-cart-dialog"
    :visible="visible"
    @close="$emit('close')"
  >
    <div class="add-cart-dialog__body">
      <div class="add-cart-dialog__swiper">
        <!-- 图片swiper -->
        <product-swiper
          v-if="data.gallery && data.gallery.length > 0"
          :gallery="data.gallery"
          pagination-style="inline"
          ref="swiper"
          :active-index="swiperIndex"
        />
        <v-lazy-img v-else />
      </div>
      <!-- 右边详情 -->
      <div class="add-cart-dialog__detail">
        <div class="add-cart-dialog__info-content">
          <div class="info-content__header">
            <div class="info-content__img d-block d-md-none">
              <a :href="data.public_url">
                <v-lazy-img :dataUrl="featureImage.url" :src="featureImage.thumbnail" />
              </a>
            </div>
            <div class="info-content__title-wrapper">
              <p class="font_title add-cart-dialog__title">{{ data.title }}</p>
              <select-price
                class="add-cart-dialog__price"
                currency_style="default"
                :appendToBody="false"
                :price="computedPrice.price"
                :regular_price_num="computedPrice.regularPrice > computedPrice.price && computedPrice.regularPrice"
                :disable_select="true"
                :show_country="showCurrencySelector"
                :country="pricetype"
              />
            </div>
          </div>

          <!-- 存在变种选择 -->
          <template v-if="variantAttrs.length > 0">
            <!-- 开启调色板 -->
            <v-product-palette
              class="add-cart-dialog__palette"
              v-if="paletteData.length > 0"
              type="detail"
              :palette_attrs="paletteData"
              :variant_attrs="selectedVariantData"
              :palette_config="paletteConfig"
              :isPopup="false"
              @change="(index, value) => handleSelected(index, value, true)"
            />

            <!-- 变种选择, 未开启调色板 -->
            <div class="add-cart-dialog__select-wrapper" v-else>
              <div class="add-cart-dialog__select" v-for="(attr, index) in variantAttrs" :key="attr.name">
                <template v-if="attr.value && attr.value.length">
                  <span v-if="showType === 'label'">{{ attr.name }}</span>
                  <variants-select
                    :showType="showType"
                    :attrs="attr.value"
                    v-model="selectedVariantData[index].value"
                    :name="attr.name"
                    @change="
                      (val) =>
                        handleSelected(index, {
                          name: attr.name,
                          value: val,
                        })
                    "
                  />
                </template>
              </div>
            </div>
          </template>

          <!-- 数量选择 -->
          <div class="add-cart-dialog__number">
            <span class="secondary_title">{{ $t('detail.quantity') }}</span>
            <inputnum
              type="productDetail"
              v-model="addCartData.quantity"
              :disabled="!buyAbale"
              theme="vogua"
              :productId="data.ID"
              :min="1"
            />
          </div>
        </div>

        <div class="add-cart-dialog__footer">
          <button
            class="home-btn home-btn--primary add-cart-dialog__button"
            :class="{
              disabled: !buyAbale,
              loading: adding,
            }"
            @click="handleAddCart"
            :disabled="!buyAbale || adding"
          >
            <span v-if="buyAbale">{{ $t('detail.add_to_cart') }}</span>
            <span v-else>{{ $t('detail.sold_out') }}</span>
          </button>

          <!-- 底部跳转链接 -->
          <p class="add-cart-dialog__link d-none d-md-block">
            <a :href="data.public_url">{{ $t('view_product_detail') }}</a>
          </p>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import SelectPrice from './common/selectprice.vue'
import InputBox from '@/views/venue/js/view/product/InputBox.vue'
import NumberLabel from '@/views/venue/js/view/product/numberLabel.vue'
import PaletteLabel from './view/productpalette/paletteLabel.vue'
import Inputnum from '@/views/venue/js/common/inputnum.vue'
import VariantsSelect from './VariantsSelect.vue'
//import LazyImg from './LazyImg.vue'
import ProductSwiper from './ProductSwiper/index.vue'
import vProductPalette from '@/js/components/view/productpalette/index.vue'

export default {
  name: 'AddCartDialog',
  components: {
    ProductSwiper,
    SelectPrice,
    InputBox,
    NumberLabel,
    PaletteLabel,
    Inputnum,
    VariantsSelect,
    //LazyImg,
    vProductPalette,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 产品数据
    data: {
      type: Object,
      require: true,
    },
    // 调色板配置
    paletteConfig: {
      default: null,
    },
  },
  emits: [
    'added', // 添加到购物车后回调
    'close',
  ],
  data() {
    return {
      // 添加到购物车数据
      addCartData: {
        quantity: 1,
        product_id: this.data.ID,
      },
      // 选中的变种信息
      selectedVariantData: this.data?.variant_attrs?.map((item) => {
        const { name, value } = item
        return {
          name,
          value: value?.[0] || '',
        }
      }),
      // 当前选中变种数据
      currentVariant: {},
      // varinatsAttrs
      variantAttrs: this.data?.variant_attrs || [],
      adding: false, // 添加中
      showType: 'label',
      buyAbale: false, // 是否可购买
      swiperIndex: 0, // 初始图片选择
    }
  },
  computed: {
    ...mapState({
      // 是否开启货币选择
      showCurrencySelector: ({ options }) => options?.theme?.global?.show_currency_selector,
      // 当前价格类型
      pricetype: ({ pricetype }) => pricetype,
      // 变种展示方式
      variantsShowConfig: ({ options }) => options?.theme?.pages?.product?.config?.variants_show_config || '',
      paletteList: (state) => state.product_palette_list || [],
    }),
    // 当前调色板信息
    paletteData() {
      const { ID } = this.data

      return this.data?.product_palette || this.paletteList?.[ID] || {}
    },
    // 产品图片，优先从变种中获取，没有的话，获取商品的
    featureImage() {
      return this.currentVariant?.feature_image || this.data.feature_image || {}
    },

    // 商品价格
    computedPrice() {
      const variants = this.data.variants_detail || []
      if (variants.length === 0) {
        return {
          price: this.data.price || 0,
          regularPrice: this.data?.regular_price || 0,
        }
      }

      return {
        price: this.currentVariant?.price || 0,
        regularPrice: this.currentVariant?.regular_price || 0,
      }
    },
  },
  /**
   * 初始化数据
   * 1、默认选中的变种信息
   * 2、默认选中的swiper
   * 3、默认选中的变种是否可购买
   */
  mounted() {
    const variants = this.data?.variants_detail || []

    // 如果存在变种的话
    if (variants.length > 0) {
      this.addCartData.variant_id = variants[0]?.ID
      this.currentVariant = variants[0]

      // 变种关联的图片
      const featureImageId = variants[0]?.feature_image?.ID || null;
      
      // 根据图片ID查找
      const { gallery } = this.data
      if (featureImageId && gallery.length > 0) {
        gallery.some((item, index) => {
          if (item.ID == featureImageId) {
            this.swiperIndex = index
          }
        })
      }
    } else {
      this.currentVariant = this.data
    }

    this.buyAbale = this.currentVariant.buy_able
  },
  methods: {
    /**
     * 切换swiper
     * 点击变种时，存在对应的图片，则swiper要切换到该图片
     */
    selectSwiper(index) {
      const swiper = this.$refs.swiper?.selectSwiper
      if (swiper) {
        swiper(index)
      }
    },
    /**
     * 选择变种
     * @params index
     * @params val 选中的值
     * @params usePropsChange 是否利用props修改了值
     * 因为历史问题，调色板直接修改props的值， 也就是当前选中的信息
     */
    handleSelected(index, val, usePropsChange = false) {
      // 产品变种
      const variants = this.data?.variants_detail

      // 当前选中的信息
      let selectedData = []
      if (!usePropsChange) {
        // 用双向绑定
        // this.selectedVariantData[index] = val
        selectedData = this.selectedVariantData
      } else {
        // 调色板是直接修改props，会导致数据慢一拍
        selectedData = cloneDeep(this.selectedVariantData)
        selectedData[index] = val
      }

      // 根据选中的信息,用变种循环的方式，选出选中的变种
      let selectedVariant = null
      variants.some((item) => {
        // 变种的属性
        const { attrs } = item

        if (attrs.length > 0) {
          const res = attrs.every((attr) => {
            return selectedData.some((selected) => {
              return attr.name === selected.name && attr.value === selected.value
            })
          })

          // 匹配成功
          if (res) {
            selectedVariant = item
          }
        }
      })

      // 如果选择的变种数据存在
      if (selectedVariant) {
        this.currentVariant = selectedVariant
        this.addCartData.variant_id = selectedVariant.ID

        const imageId = selectedVariant.feature_image?.ID
        const { gallery } = this.data

        // 切换到指定的swiper
        gallery.some((gallerItem, index) => {
          if (imageId === gallerItem.ID) {
            this.selectSwiper(index)
          }
        })

        this.buyAbale = this.currentVariant.buy_able
      } else {
        // this.currentVariant = {}
        // 不可购买
        this.buyAbale = false
        delete this.addCartData.variant_id
      }
    },
    // 添加到购物车
    async handleAddCart() {
      const { dispatch } = this.$store

      this.adding = true

      try {
        const res = await dispatch({
          type: 'product/addToCart',
          payload: {
            data: {
              ...this.addCartData,
              addType:"dialog",
            },
            productDetail: this.data,
          },
        })

        this.$emit('added', res)
      } catch (e) {
        const data = e.response?.data
        // 错误消息弹窗
        if (data?.errors) {
          Vue.prototype.$message.error(Object.values(data.errors)[0]?.[0])
        } else if (data?.message) {
          Vue.prototype.$message.error(data.message)
        }
      }

      this.adding = false
    },
  },
}
</script>
<style lang="scss">
.add-cart-dialog {
  width: 880px;
  max-width: calc(100vw - 30px);
  border-radius: 0;
  .el-dialog {
    &__header {
      padding: 0;
    }
    &__body {
      padding: 32px;
    }
  }

  @media screen and (max-width: 767px) {
    &.el-dialog {
      width: 100%;
      margin-top: unset;
      max-width: 100vw;
      position: fixed;
      left: 0;
      bottom: 0;
      margin: 0;
      transition: all 0.2s;
    }
    .el-dialog {
      &__body {
        padding: 0;
      }
      &__close {
        color: #fff;
      }
      &__headerbtn {
        width: 28px;
        height: 28px;
        border: 2px solid #fff;
        border-radius: 50%;
        left: 50%;
        top: -42px;
        margin-left: -14px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.add-cart-dialog {
  &__body {
    display: flex;
  }
  &__swiper {
    width: 448px;
    max-width: 65%;
    .product-swiper {
      margin-bottom: 0;
    }
  }
  &__detail {
    flex: 1;
    margin-left: 24px;
  }
  &__title {
    font-size: 24px;
    line-height: 33px;
  }
  &__price {
    margin-top: 12px;
    line-height: 36px;
    ::v-deep {
      .price_text,
      .regular_price_text {
        font-size: 25px;
        font-weight: bold;
      }
      * {
        line-height: 36px;
      }
    }
  }
  &__palette {
    margin-top: 24px;
    text-align: left;
    ::v-deep {
      .labelStyle {
        justify-content: start !important;
      }
    }
  }
  &__select-wrapper {
    margin-top: 24px;
  }
  &__select {
    margin-top: 18px;
    &:first-child {
      margin-top: 0;
    }
    & > span {
      font-size: 14px;
      line-height: 20px;
      color: #000;
    }
    .variant-select {
      margin-top: 6px;
    }
  }
  // 调色板样式
  &__palette {
    line-height: 0;
    ::v-deep {
      .variant_select {
        margin-top: 18px;
        &:first-child {
          margin-top: 0;
        }
        & > label {
          font-size: 14px;
          line-height: 20px;
          font-weight: normal;
          margin-bottom: 0;
          color: #000;
        }
      }
      .labelStyleBox {
        margin-top: 6px;
        .labelStyle {
          margin-left: -6px;
          margin-right: -6px;
          .labelItem {
            line-height: 0;
            padding: 6px;
            & > label {
              margin: 0;
              font-size: 13px;
              font-weight: normal;
              height: 44px;
              line-height: 44px;
              padding: 0 20px;
            }
          }
        }
      }
      .palette-label {
        &__img {
          width: 40px;
          height: 40px;
        }
      }
    }
  }
  &__number {
    margin-top: 18px;
    & > span {
      font-size: 14px;
      color: #000;
      display: block;
    }
    & > div {
      margin-top: 12px;
      display: block;
      clear: both;
      overflow: hidden;
    }
  }
  &__footer {
    margin-top: 20px;
  }
  &__button {
    width: 100%;
    max-width: unset;
  }
  &__link {
    margin-top: 40px;
    &::first-letter {
      text-transform: capitalize;
    }
    a {
      text-decoration: underline;
      &::first-letter {
        text-transform: capitalize;
      }
    }
  }

  @media screen and (max-width: 767px) {
    &__swiper {
      display: none;
    }
    &__detail {
      margin-left: 0;
    }
    &__info-content {
      padding: 20px;
      height: 400px;
      max-height: 60vh;
      overflow: auto;
      .info-content {
        &__header {
          display: flex;
          padding-bottom: 12px;
          border-bottom: 1px solid #eee;
        }
        &__img {
          height: 88px;
          width: 88px;
          margin-right: 10px;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          overflow: hidden;
          img {
            height: 100%;
            width: 100%;
            object-fit: contain;
          }
        }
        &__title-wrapper {
          flex: 1;
        }
      }
    }
    &__title {
      font-size: 14px;
      line-height: 20px;
    }
    &__palette {
      margin-top: 12px;
    }
    &__price {
      margin-top: 10px;
      line-height: 22px;
      ::v-deep {
        .price_text,
        .regular_price_text {
          font-size: 16px;
        }
      }
    }
    &__select-wrapper {
      margin-top: 12px;
    }
    &__select {
      & > span {
        font-size: 14px;
        line-height: 20px;
        display: inline-block;
      }
    }
    &__footer {
      padding: 20px;
      margin-top: 0;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.5);
    }
    &__link {
      margin-top: 20px;
    }
  }
}
</style>
